<template>
  <div>
    <div class="dashheader">
      <a-row :gutter="18">
        <a-col :sm="24" :md="24" :xl="16" :style="{ marginBottom: '24px' }">
          <AreaChartCard
            ref="areaChart"
            :loading="chartLoading"
            :title="$t('charts.totalViews')"
            :chartTips="$t('charts.totalViews')"
            :total="chartData.total"
            :rightTitle="$t('charts.dayViews')"
            :rightNum="chartData.today"
            theme="#ea4856"
            uniqueId="areacontainer1"
          ></AreaChartCard>
        </a-col>
        <a-col :sm="24" :md="24" :xl="8" :style="{ marginBottom: '24px' }">
          <a-card :body-style="{ padding: '20px 24px 8px' }" :bordered="false">
            <div class="card-header">
              <span class="card-title">{{$t('descriptions.accountInfo')}}</span>
            </div>
            <div class="card-middle">
              <img  :src="(form && form.avatar) || avatar"  class="header-avatar" />
              <div class="middle-right">
                <span class="phone">{{form.phone}}</span>
                <a-button type="link" @click="clickToEdit">{{$t('actionTitles.edit')}}</a-button>
                <br />
                <span class="address">{{form.address}}</span>
                <br />
                <a-tag color="#f50">{{$t('descriptions.profession')}}</a-tag>
                <span>{{userDetail.expire_desc}} {{$t('descriptions.expire')}}</span>
              </div>
            </div>
            <div class="card-bottom">
              <span
                class="storage-percent"
              >{{userDetail.g_use_capacity}}G/{{userDetail.g_capacity}}G</span>
              <a-progress :percent="userDetail.progress" :show-info="false" />
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <div class="dash-table">
      <a-table
        :data-source="pageResult.data"
        :loading="loading"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column
          key="name"
          :title="$t('table.common.thead.publish')"
          data-index="name"
          align="center"
        >
          <template slot-scope="text, record">
            <a-row type="flex" align="middle">
              <img :src="record.thumb_path" alt style="width:40px;border-radius: 5px;cursor:pointer;" @click="toTour(record)"/>
              <div style="margin-left:5px;">
                <span class="work-name" @click="toTour(record)">{{record.name}}</span>
                <br />
                <span>{{record.regoin_name}}</span>
              </div>
            </a-row>
          </template>
        </a-table-column>

        <a-table-column
          key="readCount"
          :sorter="(a, b) => a.total_browse - b.total_browse"
          :title="$t('table.work.thead.readCount')"
          data-index="total_browse"
          align="center"
        />

        <a-table-column
          key="status"
          :title="$t('table.common.thead.state')"
          data-index="is_public"
          :filters="filters"
          align="center"
        >
          <template slot-scope="text, record">{{$t(`enum.workIsPublic.${record.is_public}`)}}</template>
        </a-table-column>

        <a-table-column
          key="updateTime"
          :sorter="(a, b) => a.update_time - b.update_time"
          :title="$t('table.common.thead.updateTime')"
          data-index="update_time"
          align="center"
        />
      </a-table>
    </div>
  </div>
</template>

<script>
import AreaChartCard from "@/components/Charts/AreaChartCard";
import { pageQueryWork } from "@/api/work";
import { getVisitDateStatist } from "@/api/statistic";
import { mapGetters } from "vuex";
import { getUserInfo } from "@/api/user";
export default {
  components: { AreaChartCard },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      filters: [
        {
          text: `${this.$t("enum.workIsPublic[1]")}`,
          value: "1",
        },
        {
          text: `${this.$t("enum.workIsPublic[0]")}`,
          value: "0",
        },
      ],
      form: {
        avatar: "",
        phone: "",
        address: "",
      },
      chartLoading: false,
      loading: false,
      pageResult: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {
        order: {
          create_time: "desc",
          total_browse: "desc",
        },
        is_public: [],
      },
      chartData: {
        total: 0,
        today: 0,
      },
      userDetail: {},
      avatar:'/ssr/static/images/default_avatar.jpg',
    };
  },
  created() {
    this.getDatas();
    this.form = this.userInfo;
    this.userInfo.expire_time = this.userInfo.expire_time.substring(0, 11);
    getUserInfo().then((res) => {
      this.userDetail = res.data;
      this.userDetail.expire_time = this.userDetail.expire_time.substring(
        0,
        11
      );
    });
    //獲取圖表數據
    getVisitDateStatist()
      .then((res) => {
        const data = res.data;
        this.chartData.total = data.total_count;
        this.chartData.today = data.today_count;
        if (data.statistics_data) {
          this.updateChartsData(data.statistics_data);
        }
      })
      .catch((err) => {
        // this.$message.error(err);
      });
  },
  methods: {
    updateChartsData(data) {
      this.$refs.areaChart.update(data);
    },
    clickToEdit() {
      this.$router.push("/employee/account/basic");
    },
    getDatas() {
      this.loading = true;
      this.searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQueryWork(this.searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
        })
        .catch((err) => (this.loading = false));
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;

      const pager = { ...this.pagination };
      if (Object.keys(filters).length > 0) {
        this.searchParam.is_public = filters.status;
      }

      if (sorter.field === "update_time") {
        this.searchParam.order.create_time =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      if (sorter.field === "total_browse") {
        this.searchParam.order.total_browse =
          sorter.order === "ascend" ? "asc" : "desc";
      }

      this.getDatas();
    },
    toTour(item) {
       const { href } = this.$router.resolve({
        path: (item.type==2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style  scoped>
.dash-table {
  background-color: #ffffff;
}
.card-header {
  position: relative;
  overflow: hidden;
  width: 100%;
  line-height: 150%;
}

.card-title {
  color: rgba(179, 179, 179, 1);
  font-size: 14px;
}
.card-middle {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.card-bottom {
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.header-avatar {
  margin-right: 16px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
}
.middle-right {
}
.phone {
  font-size: 16px;
  color: #000000;
  text-align: left;
  font-weight: bold;
  line-height: 150%;
}
.address {
  color: rgba(166, 166, 166, 1);
  font-size: 12px;
  line-height: 150%;
  text-align: left;
}
.storage-percent {
  margin-right: 10px;
}
.work-name:hover {
  cursor: pointer;
  color: #1890ff;
}
</style>
